module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMy4yOTc0OSAxLjk2MDgxQzMuNjU1NzQgMi4zNDQ5NCAzLjY1NTc0IDIuOTQwNzcgMy4yOTc0OSAzLjMyNDkxTDEuOTE0OSA0LjgwNzM0QzEuMjk1NzQgNS40NzEyMiAwLjE4MzU5MyA1LjAzMzEgMC4xODM1OTMgNC4xMjUzTDAuMTgzNTk0IDEuMTYwNDJDMC4xODM1OTQgMC4yNTI2MTYgMS4yOTU3NCAtMC4xODU1MTEgMS45MTQ5IDAuNDc4MzdMMy4yOTc0OSAxLjk2MDgxWiIgZmlsbD0iIzY0NjQ2NCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/arrowright.svg
// module id = owWw
// module chunks = 0